import { StateCreator } from "zustand";

import { sliceResetFns } from "store";
import { IOrganizationSlice } from "../models";

const initialState = {
  organizations: [],
  currentOrganization: undefined,
};

export const createOrganizationSlice: StateCreator<
  IOrganizationSlice,
  [["zustand/devtools", never]],
  [],
  IOrganizationSlice
> = (set) => {
  sliceResetFns.add(() => set(initialState));
  return {
    ...initialState,
    setOrganizations: (organizations) => set(() => ({ organizations })),
    setCurrentOrganization: (organization) => set(() => ({ currentOrganization: organization })),
    updateCurrentOrganizationMetadata: (metadata) =>
      set((state) => ({
        currentOrganization: state.currentOrganization
          ? { ...state.currentOrganization, metadata }
          : state.currentOrganization,
      })),
    resetOrganizationSlice: () => set(() => initialState),
  };
};
